"use strict";

;
(function (ProductDescription, $) {
  var productDescriptionAccordionHeaderElementsSelector = '.product-single__description h1, .product-single__description h2, .product-single__description h3';
  var getNextSiblings = function getNextSiblings(element) {
    var siblings = [];
    while (element = element.nextSibling) {
      // DO NOT ADD <style> ELEMENTS AS SIBLINGS
      if (element.nodeName !== 'STYLE') {
        siblings.push(element);
      }
    }

    // SHOW EVERY SIBLING ELEMENT AFTER HEADING
    siblings.map(function (sibling) {
      $(sibling).slideToggle(500);
    });
  };
  var dropdownArrows = function dropdownArrows(down, right) {
    $(productDescriptionAccordionHeaderElementsSelector).each(function () {
      $(this).append("<img class='js-svg-down' src=".concat(down, " alt='open/close' />"));
    });

    // $('.product-single__description a').each(function () {
    //     $(this).append(`<img class='js-svg-right' src=${right} alt='click here' />`);
    // });
  };

  var eventHandlers = function eventHandlers() {
    $(productDescriptionAccordionHeaderElementsSelector).on('click', function () {
      var isLastDropdown = false;
      var nextEl = $(this).next();
      var last = $(productDescriptionAccordionHeaderElementsSelector).length - 1;
      var $lastHeading = $(productDescriptionAccordionHeaderElementsSelector).eq(last);

      // CHECK WHETHER THIS IS THE LAST DROPDOWN
      if ($(this).text() === $lastHeading.text()) {
        isLastDropdown = true;
      }

      // APPLY CLASSES TO SHOW ANIMATIONS
      $(this).toggleClass('is-open');
      $(this).find('.js-svg-down').toggleClass('is-open');

      // SHOW NEXT ELEMENT SIBLINGS
      if (isLastDropdown) {
        getNextSiblings(this);
      } else if (nextEl[0].tagName === 'P') {
        $(nextEl).slideToggle(500);
      }
    });
  };
  ProductDescription.init = function (downArrow, rightArrow) {
    eventHandlers();

    // ADD DROP-DOWN ARROWS ON LOAD
    dropdownArrows(downArrow, rightArrow);
  };
})(window.ProductDescription = window.ProductDescription || {}, jQuery, undefined);